import type { Project } from "./types";

type GateUser = {
  id: string;
  role: string;
  is_ceo?: boolean;
  is_technical_director?: boolean;
} | null | undefined;

/**
 * Kto może WSTRZYMAĆ / WZNOWIĆ przedsięwzięcie (akcja POST /projects/{id}/set-status/
 * ze statusem active lub suspended): CEO, dyrektor techniczny lub koordynator przypisany
 * do TEGO przedsięwzięcia. Księgowość — nie: status to decyzja prowadzącego projekt,
 * finanse tylko czytają jego historię. Lustro backendowego CanSetProjectStatus
 * (apps/accounts/permissions.py). Dezaktywacja ma osobną, ostrzejszą bramkę:
 * canDeactivateProject.
 */
export function canSetProjectStatus(
  user: GateUser,
  project: Pick<Project, "coordinators"> | null | undefined,
): boolean {
  if (!user || !project) return false;
  if (user.is_ceo) return true;
  if (user.role === "director" && user.is_technical_director === true) return true;
  return user.role === "coordinator" && project.coordinators.includes(user.id);
}

/**
 * Kto może DEZAKTYWOWAĆ przedsięwzięcie (set-status/ ze statusem inactive): stara
 * bramka finansowa bez księgowości — CEO albo dyrektor techniczny z dostępem
 * finansowym do TEGO przedsięwzięcia (dla dyrektora `has_finance_access` z serializera
 * = grant ProjectFinanceAccess). Koordynator może wstrzymać swój projekt, ale nie
 * zamknąć go. Lustro CanSetProjectStatus.can_deactivate.
 */
export function canDeactivateProject(
  user: GateUser,
  project: Pick<Project, "has_finance_access"> | null | undefined,
): boolean {
  if (!user || !project) return false;
  if (user.is_ceo) return true;
  return (
    user.role === "director" &&
    user.is_technical_director === true &&
    project.has_finance_access === true
  );
}
